import CryptoJS from 'crypto-js'

export default {
  encrypt(password) {
    const encryptedPassword = CryptoJS.SHA256(password).toString(CryptoJS.enc.Hex)
    return encryptedPassword
  }
}
